'use client';

import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { queryClient } from '@/providers/queryClient';

export default function QueryClientProvider({ children }: { children: React.ReactNode }) {
  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}
